import { render, staticRenderFns } from "./Navigation.vue?vue&type=template&id=4dd303c5&"
import script from "./Navigation.vue?vue&type=script&lang=ts&"
export * from "./Navigation.vue?vue&type=script&lang=ts&"
import style0 from "./Navigation.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4dd303c5')) {
      api.createRecord('4dd303c5', component.options)
    } else {
      api.reload('4dd303c5', component.options)
    }
    module.hot.accept("./Navigation.vue?vue&type=template&id=4dd303c5&", function () {
      api.rerender('4dd303c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Navigation/Navigation.vue"
export default component.exports